var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"basic-search-form-wrap"},[_c('div',{staticClass:"basic-search-form-grid grey lighten-3"},[_c('SearchForm',_vm._b({staticClass:"basic-search-content align-center pa-3"},'SearchForm',_vm.$props,false))],1)])}
var staticRenderFns = []

export { render, staticRenderFns }